import React, { useState, useRef, useEffect } from 'react';

const TEMPLATES = [
  { value: 'regular', label: 'Regular Corporate' },
  { value: 'osmsaas', label: 'OSM SAAS' },
  { value: 'esomarlogo', label: 'ESOMAR Individual Member' },
  { value: 'esomar', label: 'ESOMAR Corporate Member' },
  { value: 'rv', label: 'RV Special Signature' },
];

const ESOMAR_INDIVIDUAL_LOGO = 'https://res.cloudinary.com/divergent/image/upload/v1775727462/signature/esomar_euguuq.png';
const ESOMAR_CORPORATE_LOGO = 'https://res.cloudinary.com/divergent/image/upload/v1775726306/signature/ESOMAR_corporate2025_RGB_glhrev.png';
const CREDENTIALS_DECK = 'https://res.cloudinary.com/divergent/image/upload/v1785763607/Dive%20In%20Credentials/DI_-_GLOBAL_DECK_26_yjiio2.pdf';

// Busted once per page load, not per render, so the preview images don't
// reload on every keystroke.
const CACHE_BUST = Date.now();
const cacheBust = url => `${url}?t=${CACHE_BUST}`;

function generateOSMSaaSSignature(name, designation, mobile) {
  return `
    <tr>
      <td valign="top" style="padding:0px 8px 0 0;">
        <img src="${cacheBust('https://res.cloudinary.com/divergent/image/upload/v1719384781/signature/sign-logo_nquvsk.png')}">
      </td>
      <td valign="top" style="padding:0px 8px 0 0;">
        <div style="line-height:1em;font-size:0.8em;font-family:Arial;padding-top:5px;color:#5d2d91;font-weight:bold">Creating Value Through Collaboration</div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1.1em;font-size:0.7em;padding-top:2px;font-family:Arial;">
          <b>SINGAPORE | INDIA | INDONESIA | VIETNAM <br>SOUTH KOREA | UAE </b>
        </div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;">Download Credentials
          <a href="${CREDENTIALS_DECK}">here</a>
        </div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;padding-top:5px;color:#5d2d91;"><b><span style="color:#000">Coverage:</span>ASIA, LATAM, GCC</b></div>
      </td>
      <td valign="top" style="font-size:80%;font-family:Arial;border-left:3px solid;border-color:#5d2d91;padding:0px 0 0 8px;">
        <div style="font-size:1.2em;color:#5d2d91;margin-top:4px;"><b>${name}</b></div>
        <div style="line-height:0.7em;font-size:0.7em;">&nbsp;</div>
        <div><span><span style="font-size:1em;line-height:1.5em;font-weight:bold">${designation}</span>&nbsp;&nbsp;</span></div>
        <div>
          <span>
            <span style="font-size:0.8em;color:#5d2d91;"><b>Mobile:</b></span>
            <span style="font-size:0.8em;">${mobile}</span>
          </span>
        </div>
      </td>
    </tr>
  `;
}

function generateBaseSignature(name, designation, mobile, isEsomar, mobileSg, kakaotalk, esomarLogoUrl) {
  return `
    <tr>
      <td valign="top" style="padding:0px 8px 0 0;">
        <img src="${cacheBust('https://res.cloudinary.com/divergent/image/upload/v1719384781/signature/sign-logo_nquvsk.png')}">
      </td>
      <td valign="top" style="padding:0px 8px 0 0;">
        <div style="line-height:1em;font-size:0.8em;font-family:Arial;padding-top:5px;color:#5d2d91;font-weight:bold">Creating Value Through Collaboration</div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1.1em;font-size:0.7em;padding-top:2px;font-family:Arial;">
          <b>SINGAPORE | INDIA | INDONESIA | VIETNAM <br>SOUTH KOREA | UAE </b>
        </div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;">Download Credentials
          <a href="${CREDENTIALS_DECK}">here</a>
        </div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;padding-top:5px;color:#5d2d91;"><b><span style="color:#000">Coverage:</span>ASIA, LATAM, GCC</b></div>
      </td>
      <td valign="top" style="font-size:80%;font-family:Arial;border-left:3px solid;border-color:#5d2d91;padding:0px 0 0 8px;">
        <div style="font-size:1.2em;color:#5d2d91;margin-top:4px;"><b>${name}</b></div>
        <div style="line-height:0.7em;font-size:0.7em;">&nbsp;</div>
        <div><span><span style="font-size:1em;line-height:1.5em;font-weight:bold">${designation}</span>&nbsp;&nbsp;</span></div>
        ${isEsomar && !esomarLogoUrl
          ? `<div><span><span style="font-size:1em;line-height:1.5em;font-weight:bold;color:#5D2D91">ESOMAR MEMBER</span>&nbsp;&nbsp;</span></div>`
          : ''}
        ${mobileSg
          ? `<div><span><span style="font-size:0.8em;color:#5d2d91;"><b>Mobile(India): </b></span><span style="font-size:0.8em;">${mobile}</span></span></div>
             <div><span><span style="font-size:0.8em;color:#5d2d91;"><b>Mobile(Singapore): </b></span><span style="font-size:0.8em;">${mobileSg}</span></span></div>
             <div><span><span style="font-size:0.8em;color:#5d2d91;"><b>KakaoTalk: </b></span><span style="font-size:0.8em;">${kakaotalk}</span></span></div>`
          : `<div><span><span style="font-size:0.8em;color:#5d2d91;"><b>Mobile:</b></span><span style="font-size:0.8em;">${mobile}</span></span></div>`}
        ${esomarLogoUrl || mobileSg
          ? `<div style="padding-top:10px"><span><span><img src="${esomarLogoUrl || cacheBust(ESOMAR_INDIVIDUAL_LOGO)}" style="display:block;max-width:120px;max-height:42px;width:auto;height:auto;"></span></span></div>`
          : ''}
      </td>
    </tr>
  `;
}

function buildSignatureHTML(template, name, designation, mobile, mobileSg, kakaotalk, showBanner) {
  let rowsHTML = '';
  let rvImageHTML = '';

  if (template === 'rv') {
    rvImageHTML = `
      <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:8px;">
        <tr>
          <td>
            <img src="${cacheBust('https://res.cloudinary.com/divergent/image/upload/v1719384781/signature/rvsign_ocyblk.jpg')}" style="display:block; max-width:100%; height:auto;" border="0">
          </td>
        </tr>
      </table>
    `;
    rowsHTML = generateBaseSignature(name, designation, mobile, false, mobileSg, kakaotalk, cacheBust(ESOMAR_CORPORATE_LOGO));
  } else if (template === 'osmsaas') {
    rowsHTML = generateOSMSaaSSignature(name, designation, mobile);
  } else {
    rowsHTML = generateBaseSignature(
      name, designation, mobile,
      template !== 'regular',
      null, null,
      template === 'esomarlogo'
        ? cacheBust(ESOMAR_INDIVIDUAL_LOGO)
        : template === 'esomar'
        ? cacheBust(ESOMAR_CORPORATE_LOGO)
        : null
    );
  }

  // Royal Aurora banner — VaultCX purple panel with badge + "Book a demo" CTA.
  const bannerHTML = showBanner
    ? `<tr>
        <td colspan="3" bgcolor="#5D2D91" style="background-color:#5D2D91; padding:14px 16px; border-top:3px solid #783ABB; mso-line-height-rule:exactly;">
          <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" bgcolor="#5D2D91" style="background-color:#5D2D91; border-collapse:separate; border-spacing:0; mso-table-lspace:0pt; mso-table-rspace:0pt;">
            <tr>
              <td valign="middle" width="48" bgcolor="#5D2D91" style="background-color:#5D2D91; padding-right:10px; vertical-align:middle; text-align:left;">
                <img src="${cacheBust('https://res.cloudinary.com/divergent/image/upload/v1786471097/signature/vaultcx-badge-shimmer_dvw49d.gif')}" width="44" height="44" style="display:block; width:44px; height:44px; border:0;" alt="VaultCX Badge" border="0">
              </td>
              <td valign="middle" bgcolor="#5D2D91" style="background-color:#5D2D91; vertical-align:middle; text-align:left; font-family:Arial, sans-serif;">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" bgcolor="#5D2D91" style="background-color:#5D2D91; border-collapse:separate; border-spacing:0;">
                  <tr>
                    <td bgcolor="#5D2D91" style="background-color:#5D2D91; font-family:Arial, sans-serif; font-size:15px; font-weight:bold; color:#FFFFFF; line-height:1.2;">
                      Vault<span style="color:#8FC73E;">CX</span> <span style="font-size:8.5px; font-weight:bold; color:#E2D1F9; padding-left:4px;">CUSTOMER EXPERIENCE PLATFORM</span>
                    </td>
                  </tr>
                  <tr>
                    <td bgcolor="#5D2D91" style="background-color:#5D2D91; font-family:Arial, sans-serif; font-size:11.5px; font-weight:bold; color:#FFFFFF; padding-top:3px; line-height:1.3;">
                      From Survey Design to Decision-Ready Insights
                    </td>
                  </tr>
                  <tr>
                    <td bgcolor="#5D2D91" style="background-color:#5D2D91; font-family:Arial, sans-serif; font-size:9.5px; color:#CBB1E7; padding-top:3px;">
                      Powered by <a href="https://divergentinsights.com/" style="color:#8FC73E; text-decoration:none !important; font-weight:bold;"><span style="color:#8FC73E; text-decoration:none !important;">Divergent Insights</span></a>
                    </td>
                  </tr>
                </table>
              </td>
              <td valign="middle" align="right" width="125" bgcolor="#5D2D91" style="background-color:#5D2D91; padding-left:10px; vertical-align:middle; text-align:right;">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" align="right" bgcolor="#8FC73E" style="background-color:#8FC73E; border-collapse:separate; border-spacing:0;">
                  <tr>
                    <td align="center" bgcolor="#8FC73E" style="background-color:#8FC73E; padding:8px 14px; border-radius:18px; mso-line-height-rule:exactly; line-height:1.2;">
                      <a href="https://cal.id/vaultcx-team/product-demo?user=vaultcx-team&amp;duration=60" style="font-family:Arial, sans-serif; font-weight:bold; font-size:10px; color:#1A1A2E; text-decoration:none !important; white-space:nowrap; display:inline-block;"><span style="color:#1A1A2E; text-decoration:none !important;">BOOK A DEMO</span></a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>`
    : '';

  const osmFooter = template === 'osmsaas'
    ? `<tr>
        <td valign="top" style="padding:0px;border-top:3px solid;border-color:#5d2d91;" colspan="3">
          <table width="100%" cellpadding="0" cellspacing="0" style="font-family:Arial,sans-serif;background-color:#f5f5f5;">
            <tr><td style="padding:6px 12px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <!-- Row 1: RapidSay Branding with small logo -->
                <tr><td style="padding-bottom:4px;border-bottom:1px solid #ede9f0;">
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tr>
                      <td valign="top" style="padding-right:6px;width:28px;">
                        <a href="https://gmos.rapidsay.com/" style="text-decoration:none;" target="_blank">
                          <img src="https://gmos.rapidsay.com/media/logos/gmos_logo.png" style="height:28px;width:auto;display:block;border-radius:2px;">
                        </a>
                      </td>
                      <td valign="middle" style="padding-left:4px;">
                        <div style="font-size:11px;color:#5d2d91;font-weight:bold;line-height:1.2;margin-bottom:1px;">RapidSay – Global Survey Sampling</div>
                        <div style="font-size:9px;color:#6d5d8f;line-height:1.3;font-weight:500;">Your trusted platform for global survey sampling and respondent access.</div>
                      </td>
                    </tr>
                  </table>
                </td></tr>
                <!-- Row 2: OSM Branding -->
                <tr><td style="padding:5px 0px;border-bottom:1px solid #ede9f0;">
                  <div style="font-size:10px;color:#5d2d91;line-height:1.4;font-weight:600;">An all-in-one online survey management platform for seamless project bidding, execution, and delivery.</div>
                <div style="font-size:12px;color:#5d2d91;font-weight:bold;margin-bottom:1px;text-align:center;">🚀 Powered by OSM</div>
                  </td></tr>
                <!-- Row 3: Feature Highlights with checkmarks -->
                <tr><td style="padding:5px 0px;border-bottom:1px solid #ede9f0;background-color:#fcfbfd;">
                  <table width="100%" cellpadding="2" cellspacing="0" style="background-color:#fcfbfd;">
                    <tr><td align="center" style="font-size:10px;color:#5d2d91;line-height:1.5;font-weight:600;">
                      <span style="color:#5d2d91;font-weight:bold;">✓</span> Smart Bidding&nbsp;&nbsp;
                      <span style="color:#5d2d91;">|</span>&nbsp;&nbsp;
                      <span style="color:#5d2d91;font-weight:bold;">✓</span> Multi Country Projects&nbsp;&nbsp;
                      <span style="color:#5d2d91;">|</span>&nbsp;&nbsp;
                      <span style="color:#5d2d91;font-weight:bold;">✓</span> White Label
                    </td></tr>
                  </table>
                </td></tr>
                <!-- Row 4: Call To Action Button -->
                <tr><td style="padding:7px 0px;text-align:center;">
                  <a href="https://osm.diverhentinsights.com/" style="background-color:#5d2d91;color:#ffffff;text-decoration:none;font-weight:bold;font-size:11px;padding:7px 18px;display:inline-block;border-radius:3px;letter-spacing:0.3px;box-shadow:0 2px 4px rgba(93,45,145,0.2);" target="_blank">📅 BOOK A DEMO HERE</a>
                </td></tr>
              </table>
            </td></tr>
          </table>
        </td>
      </tr>`
    : '';

  return { rvImageHTML, tableBodyHTML: rowsHTML + bannerHTML + osmFooter };
}

export default function SignatureGenerator() {
  const [template, setTemplate] = useState('regular');
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [mobile, setMobile] = useState('');
  const [mobileSg, setMobileSg] = useState('');
  const [kakaotalk, setKakaotalk] = useState('');
  const [showBanner, setShowBanner] = useState(true);
  const [copyMsg, setCopyMsg] = useState('');
  const previewRef = useRef(null);

  // Fallbacks so the live preview stays readable while fields are still blank.
  const { rvImageHTML, tableBodyHTML } = buildSignatureHTML(
    template,
    name.trim() || '[Your Full Name]',
    designation.trim() || '[Your Designation / Title]',
    mobile.trim() || '[Your Mobile Number]',
    template === 'rv' ? (mobileSg.trim() || '[Your SG Mobile]') : mobileSg,
    template === 'rv' ? (kakaotalk.trim() || '[Your KakaoTalk]') : kakaotalk,
    showBanner
  );

  const fullPreviewHTML = `${rvImageHTML}<table class="signature-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="560" bgcolor="#FFFFFF" style="border:1px solid #5D2D91; border-collapse:separate; border-spacing:0; background-color:#FFFFFF; margin:0; mso-table-lspace:0pt; mso-table-rspace:0pt;"><tbody>${tableBodyHTML}</tbody></table>`;

  const handleCopy = () => {
    const el = previewRef.current;
    if (!el) return;
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    document.execCommand('copy');
    sel.removeAllRanges();
    setCopyMsg('Signature copied to clipboard!');
    setTimeout(() => setCopyMsg(''), 3000);
  };

  const styles = {
    page: {
      background: '#f5f5f5',
      minHeight: '100vh',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      gap: '40px',
      flexWrap: 'wrap',
    },
    inputSection: {
      flex: 1,
      minWidth: '300px',
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    previewSection: {
      flex: 2,
      minWidth: '500px',
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    h1: {
      color: '#5d2d91',
      marginBottom: '20px',
      fontSize: '1.6rem',
    },
    formGroup: {
      marginBottom: '15px',
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      color: '#333',
      fontSize: '14px',
    },
    input: {
      width: '100%',
      padding: '8px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
    },
    select: {
      width: '100%',
      padding: '8px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
    },
    btnPrimary: {
      background: '#5d2d91',
      color: '#fff',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '15px',
      marginRight: '10px',
      marginTop: '10px',
    },
    btnCopy: {
      background: '#28a745',
      color: '#fff',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '15px',
      marginTop: '10px',
    },
    copyMsg: {
      color: '#28a745',
      marginTop: '8px',
      fontSize: '14px',
      fontWeight: 600,
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Input Section */}
        <div style={styles.inputSection}>
          <h1 style={styles.h1}>Signature Generator</h1>

          <div style={styles.formGroup}>
            <label style={styles.label}>Select Template:</label>
            <select
              style={styles.select}
              value={template}
              onChange={e => setTemplate(e.target.value)}
            >
              {TEMPLATES.map(t => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Name:</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Designation:</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your designation"
              value={designation}
              onChange={e => setDesignation(e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Mobile Number:</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your mobile number"
              value={mobile}
              onChange={e => setMobile(e.target.value)}
            />
          </div>

          {/* RV-only fields */}
          {template === 'rv' && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>Mobile (Singapore):</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="Enter Singapore mobile number"
                  value={mobileSg}
                  onChange={e => setMobileSg(e.target.value)}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>KakaoTalk:</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="Enter KakaoTalk ID"
                  value={kakaotalk}
                  onChange={e => setKakaotalk(e.target.value)}
                />
              </div>
            </>
          )}

          <div style={styles.formGroup}>
            <label style={{ ...styles.label, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={showBanner}
                onChange={e => setShowBanner(e.target.checked)}
              />
              Include Signature Banner
            </label>
          </div>

          <div>
            <button style={styles.btnCopy} onClick={handleCopy}>
              Copy Signature
            </button>
          </div>
          {copyMsg && <div style={styles.copyMsg}>{copyMsg}</div>}
        </div>

        {/* Preview Section */}
        <div style={styles.previewSection}>
          <h1 style={styles.h1}>Preview</h1>
          {/* notranslate/translate="no": the signature must keep its original
              English text — this node is also the clipboard copy source */}
          <div
            ref={previewRef}
            className="notranslate"
            translate="no"
            dangerouslySetInnerHTML={{ __html: fullPreviewHTML }}
          />
        </div>
      </div>
    </div>
  );
}
